import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  CustomColoredDropdown,
  formatShortMonthDateYearWithTime,
  PAYMENT_OPTIONS,
  STATUS_OPTIONS,
} from "../../include/function";
import { ChevronDown } from "react-feather";
import { adminReqConfig, api } from "../../include/api";

const DashboardOrders = () => {
  const [selectedData, setSelectedData] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [expandedRows, setExpandedRows] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [orderData, setOrderData] = useState([]);

  const navigate = useNavigate();
  const handleOrderDetailClick = (orderId) => {
    navigate(`/admin/order-details/${orderId}`);
  };

  const getOrders = () => {
    setFetchLoading(true);

    const url = `/orders/`;

    api
      .get(url, adminReqConfig())
      .then((response) => {
        if (response.status === 200) {
          const normalizedData = response.data.data.map((order) => ({
            ...order,
            orderItems: order.orderItems.map((item) => ({
              ...item,
              status: item.status?.toLowerCase(),
            })),
          }));
          setOrderData(normalizedData);
          setFilteredData(normalizedData);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch orders:", error);
        setOrderData([]);
        setFilteredData([]);
      })
      .finally(() => setFetchLoading(false));
  };

  useEffect(() => {
    getOrders();
  }, []);
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = currentItems.map((p) => p.id);
      setSelectedData((prev) => [...new Set([...prev, ...allIds])]);
    } else {
      const idsToRemove = currentItems.map((p) => p.id);
      setSelectedData((prev) => prev.filter((id) => !idsToRemove.includes(id)));
    }
  };
  const handleSelectOne = (id) => {
    setSelectedData((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id],
    );
  };
  //Row expand/collapse
  const toggleExpand = (orderId) => {
    setExpandedRows((prev) =>
      prev.includes(orderId)
        ? prev.filter((id) => id !== orderId)
        : [...prev, orderId],
    );
  };
  //Pagination logic
  let currentItems = [];
  let totalPage = 1;
  let showingFrom = 0;
  let showingTo = 0;
  if (itemsPerPage === "all") {
    currentItems = filteredData;
    showingFrom = filteredData.length > 0 ? 1 : 0;
    showingTo = filteredData.length;
  } else {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    totalPage = Math.ceil(filteredData.length / itemsPerPage);
    showingFrom = indexOfFirstItem + 1;
    showingTo = Math.min(indexOfLastItem, filteredData.length);
  }

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const formatOrderId = (order) => {
    if (!order?.createTimestamp || !order?.id) return "ORD--";

    // Extract last 2 digits of year
    const year = new Date(order.createTimestamp).getFullYear();
    const yy = String(year).slice(-2); // e.g., 2025 → "25"

    // Zero-pad order.id to 4 digits
    const paddedId = String(order.id).padStart(4, "0"); // e.g., 7 → "0007"

    return `ORD${yy}-${paddedId}`;
  };

  return (
    <div>
      {" "}
      <div className="rounded-5 bg-white py-24">
        <div className="d-flex justify-content-between p-10">
          <div>
            <h6 className="mb-0 fs-6">Recent Orders</h6>
          </div>
          <div>
            {" "}
            <Link
              className="dash-status-botton-btn fs-6"
              to="/admin/sales/orders"
            >
              View more
            </Link>
          </div>
        </div>
        {/* Table */}
        <div className="table-responsive mt-24 product-table">
          <table className="table table-striped custom-striped-table-product-list align-middle">
            <thead>
              <tr>
                <th scope="col">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    style={{ borderColor: "#c5d5f5" }}
                    onChange={handleSelectAll}
                    checked={
                      currentItems.length > 0 &&
                      currentItems.every((p) => selectedData.includes(p.id))
                    }
                  />
                </th>
                <th
                  scope="col"
                  style={{ fontSize: "15px", textWrap: "nowrap" }}
                >
                  Order ID
                </th>
                <th
                  scope="col"
                  style={{ fontSize: "15px", textWrap: "nowrap" }}
                >
                  Product Name
                </th>
                <th
                  scope="col"
                  style={{ fontSize: "15px", textWrap: "nowrap" }}
                >
                  Customer Name
                </th>
                <th
                  scope="col"
                  style={{ fontSize: "15px", textWrap: "nowrap" }}
                >
                  Customer Type
                </th>
                <th
                  scope="col"
                  style={{ fontSize: "15px", textWrap: "nowrap" }}
                >
                  Date & Time
                </th>
                <th
                  scope="col"
                  style={{ fontSize: "15px", textWrap: "nowrap" }}
                >
                  Quantity
                </th>
                <th
                  scope="col"
                  style={{ fontSize: "15px", textWrap: "nowrap" }}
                >
                  Total Amount
                </th>

                <th
                  scope="col"
                  style={{ fontSize: "15px", textWrap: "nowrap" }}
                >
                  Payment Status
                </th>
                <th
                  scope="col"
                  style={{ fontSize: "15px", textWrap: "nowrap" }}
                >
                  Delivery Address
                </th>
                <th
                  scope="col"
                  style={{ fontSize: "15px", textWrap: "nowrap" }}
                >
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((order) => {
                  const isMulti = order.orderItems.length > 1;
                  const isExpanded = expandedRows.includes(order.id);

                  const isOverdue =
                    order?.orderItems[0]?.status.toLowerCase() ===
                    "need-approval";
                  return (
                    <React.Fragment key={order.id}>
                      <tr className={isOverdue ? "overdue-row" : undefined}>
                        <td>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ borderColor: "#c5d5f5" }}
                            checked={selectedData.includes(order.id)}
                            onChange={() => handleSelectOne(order.id)}
                          />
                        </td>
                        <td>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              textWrap: "nowrap",
                            }}
                          >
                            {order.orderItems.length > 1 && (
                              <button
                                style={{
                                  border: "2px solid #006fbf",
                                  color: "#006fbf",
                                  background: "transparent",
                                  borderRadius: "4px",
                                  width: "14px",
                                  height: "14px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  fontSize: "12px",
                                  cursor: "pointer",
                                }}
                                onClick={() => toggleExpand(order.id)}
                              >
                                {isExpanded ? "−" : "+"}
                              </button>
                            )}
                            <span
                              className={
                                isOverdue ? "over-due-color" : undefined
                              }
                            >
                              {formatOrderId(order)}
                            </span>
                          </div>
                        </td>
                        <td style={{ width: "15%" }}>
                          <button
                            onClick={() => handleOrderDetailClick(order.id)}
                            style={{
                              background: "none",
                              border: "none",
                              // color: "#006fbf",
                              // textDecoration: "underline",
                              cursor: "pointer",
                              padding: 0,
                              fontSize: "inherit",
                            }}
                            title="View Order Details"
                          >
                            {isMulti ? (
                              <>
                                <span
                                  className={
                                    isOverdue ? "over-due-color" : undefined
                                  }
                                >
                                  {order.orderItems[0]?.productName}
                                </span>
                                <span
                                  className={
                                    isOverdue
                                      ? "over-due-color"
                                      : "text-primary"
                                  }
                                >
                                  {" "}
                                  + {order.orderItems.length - 1} Items
                                </span>
                              </>
                            ) : (
                              <span
                                className={
                                  isOverdue ? "over-due-color" : undefined
                                }
                              >
                                {order.orderItems[0]?.productName}
                              </span>
                            )}
                          </button>
                        </td>

                        <td>
                          <span
                            className={isOverdue ? "over-due-color" : undefined}
                          >
                            {order.name}
                          </span>
                        </td>
                        <td>
                          <span
                            className={isOverdue ? "over-due-color" : undefined}
                          >
                            {order.customerType
                              ? `${order.customerType} (${
                                  order.customerType === "individual"
                                    ? "B2C"
                                    : "B2B"
                                })`
                              : "N/A"}
                          </span>
                        </td>
                        <td>
                          <span
                            className={isOverdue ? "over-due-color" : undefined}
                          >
                            {formatShortMonthDateYearWithTime(
                              order.createTimestamp,
                            )}
                          </span>
                        </td>
                        <td>
                          <span
                            className={isOverdue ? "over-due-color" : undefined}
                          >
                            {order.totalItems}
                          </span>
                        </td>
                        <td>
                          <span
                            className={isOverdue ? "over-due-color" : undefined}
                          >
                            ₹{Math.round(order.totalAmount).toLocaleString()}
                          </span>
                        </td>
                        <td>
                          {order.paymentStatus && (
                            <CustomColoredDropdown
                              value={order.paymentStatus}
                              options={PAYMENT_OPTIONS}
                              type="payment"
                              disable={true}
                            />
                          )}
                        </td>
                        <td>
                          <span
                            className={isOverdue ? "over-due-color" : undefined}
                          >
                            {order.address}, {order.locality}, {order.city},
                            {order.state}
                          </span>
                        </td>
                        <td>
                          {!isMulti && order.orderItems[0]?.status && (
                            <CustomColoredDropdown
                              value={order.orderItems[0]?.status}
                              options={STATUS_OPTIONS}
                              type="status"
                              disable={true}
                            />
                          )}
                        </td>
                      </tr>
                      {isExpanded &&
                        order.orderItems.map((item, idx) => (
                          <tr key={item.id} className="bg-light">
                            <td></td>
                            <td style={{ paddingLeft: "30px" }}>{idx + 1}.</td>
                            <td>{item.productName}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>{item.qty}</td>
                            <td>₹{Math.round(item.amount).toLocaleString()}</td>
                            <td></td>
                            <td></td>
                            <td>
                              {item.status && (
                                <CustomColoredDropdown
                                  value={item.status}
                                  options={STATUS_OPTIONS}
                                  type="status"
                                  disable={true}
                                />
                              )}
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="11" className="text-center py-3">
                    No orders found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="d-flex justify-content-between align-items-center mt-16 p-16">
          <div className="d-flex align-items-center">
            <select
              className="form-select d-inline-block w-auto"
              value={itemsPerPage}
              onChange={(e) => {
                const val = e.target.value;
                setItemsPerPage(val === "all" ? "all" : parseInt(val));
                setCurrentPage(1);
              }}
              style={{
                height: "34px",
                fontSize: "14px",
                minWidth: "70px",
              }}
            >
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="all">All</option>
            </select>
            <span className="ms-2">
              Showing {showingFrom} to {showingTo} of {filteredData.length}{" "}
              orders
            </span>
          </div>
          <nav>
            <ul className="pagination mt-0">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => paginate(currentPage - 1)}
                >
                  &laquo;
                </button>
              </li>
              {(() => {
                const pagesToShow = 5;
                let startPage = Math.max(
                  1,
                  currentPage - Math.floor(pagesToShow / 2),
                );
                let endPage = startPage + pagesToShow - 1;
                if (endPage > totalPage) {
                  endPage = totalPage;
                  startPage = Math.max(1, endPage - pagesToShow + 1);
                }
                const pageNumbers = [];
                for (let i = startPage; i <= endPage; i++) {
                  pageNumbers.push(i);
                }
                return pageNumbers.map((pageNum) => (
                  <li
                    key={pageNum}
                    className={`page-item ${
                      currentPage === pageNum ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => paginate(pageNum)}
                    >
                      {pageNum}
                    </button>
                  </li>
                ));
              })()}
              <li
                className={`page-item ${
                  currentPage === totalPage ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => paginate(currentPage + 1)}
                >
                  &raquo;
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default DashboardOrders;
